/**
 * Try Before You Buy quick buy.
 *
 * Product cards always render their Try with Mirra selling plan in
 * `data-tbyb-selling-plan`. This file only runs on a collection section marked
 * with `data-tbyb-collection`, where it:
 *   - keeps `data-tbyb-cart-has-try` on that section in sync with the cart
 *     (the CSS in snippets/product-quick-buy.liquid does the button swap), and
 *   - adds the selling plan to a card's add to cart request while Try is offered.
 */
(() => {
  const section = document.querySelector("[data-tbyb-collection]");
  if (!section) return;

  const TRY_PLAN_NAME = "Try with Mirra";

  const isTryOffered = () => !section.hasAttribute("data-tbyb-cart-has-try");

  section.addEventListener(
    "submit",
    (event) => {
      const form = event.target.closest(".quick-buy-product-form");
      if (!form) return;

      form
        .querySelectorAll('input[name="selling_plan"]')
        .forEach((input) => input.remove());

      const sellingPlanId = form.dataset.tbybSellingPlan;
      if (!sellingPlanId || !isTryOffered()) return;

      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "selling_plan";
      input.value = sellingPlanId;
      form.appendChild(input);

      // The form's own submit handler builds its FormData after this one runs
      setTimeout(() => input.remove(), 0);
    },
    true,
  );

  const refresh = async () => {
    try {
      const res = await fetch(`${window.theme.routes.cart_url}.js`);
      const cart = await res.json();
      const hasTryItem = cart.items.some(
        (item) =>
          item.selling_plan_allocation?.selling_plan.name === TRY_PLAN_NAME,
      );

      section.toggleAttribute("data-tbyb-cart-has-try", hasTryItem);
    } catch (error) {
      console.error("[tbyb-quick-buy] Cart refresh failed:", error);
    }
  };

  window.addEventListener("switch:cart:afteradditem", refresh);
  window.addEventListener("switch:modalcart:cartqtychange", refresh);
})();
